/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from "@/shared/api/axiosInstance";
import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
} from "@/shared/api/axiosInstance";
import type {
  GetApiV1ExamLanguageDropdownQueryResponse,
  GetApiV1ExamLanguageDropdown401,
  GetApiV1ExamLanguageDropdown500,
} from "../../types/examSharedController/GetApiV1ExamLanguageDropdown.ts";

function getGetApiV1ExamLanguageDropdownUrl() {
  const res = { method: "GET", url: `/api/v1/exam/language-dropdown` as const };
  return res;
}

/**
 * @description Retorna a lista de idiomas suportados para uso em componentes de seleção, com o código de cultura como chave e o nome do idioma em português como valor. **(Requer Authorization para autenticação)**
 * @summary Lista de idiomas para dropdown (Requer Authorization para autenticação)
 * {@link /api/v1/exam/language-dropdown}
 */
export async function getApiV1ExamLanguageDropdown(
  config: Partial<RequestConfig> & { client?: Client } = {},
) {
  const { client: request = fetch, ...requestConfig } = config;

  const res = await request<
    GetApiV1ExamLanguageDropdownQueryResponse,
    ResponseErrorConfig<
      GetApiV1ExamLanguageDropdown401 | GetApiV1ExamLanguageDropdown500
    >,
    unknown
  >({
    method: "GET",
    url: getGetApiV1ExamLanguageDropdownUrl().url.toString(),
    ...requestConfig,
  });
  return res.data;
}
